<template>
  <app-fun></app-fun>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue